/**
 * @generated SignedSource<<3348ab3bb66b64789824e1a3d417cca2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
export type MembersProfileFieldFilterQuery$variables = {
  after?: string | null;
  first: number;
  id: string;
  isPrivate?: boolean | null;
  search?: string | null;
  webFormQuestionTypes?: ReadonlyArray<WebFormQuestionType> | null;
};
export type MembersProfileFieldFilterQuery$data = {
  readonly organization: {
    readonly profileFieldsForFiltering?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly title: string;
          readonly " $fragmentSpreads": FragmentRefs<"MembersProfileFieldFilterOptionFragment">;
        };
      }>;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
        readonly hasPreviousPage: boolean;
        readonly startCursor: string | null;
      };
    };
  } | null;
};
export type MembersProfileFieldFilterQuery = {
  response: MembersProfileFieldFilterQuery$data;
  variables: MembersProfileFieldFilterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPrivate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "webFormQuestionTypes"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v7 = {
  "kind": "Literal",
  "name": "defaultTypesToExclude",
  "value": [
    "email_address",
    "public_groups"
  ]
},
v8 = {
  "kind": "Variable",
  "name": "isPrivate",
  "variableName": "isPrivate"
},
v9 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v10 = {
  "kind": "Literal",
  "name": "status",
  "value": "visible"
},
v11 = {
  "kind": "Variable",
  "name": "webFormQuestionTypes",
  "variableName": "webFormQuestionTypes"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoObjectType",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MembersProfileFieldFilterQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "profileFieldsForFiltering",
                "args": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "concreteType": "ProfileFieldNodeConnection",
                "kind": "LinkedField",
                "name": "__MembersProfileFieldFilter__profileFieldsForFiltering_connection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileFieldNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileField",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "MembersProfileFieldFilterOptionFragment"
                          },
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "MembersProfileFieldFilterQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "profileFieldsForFiltering",
                "args": (v17/*: any*/),
                "concreteType": "ProfileFieldNodeConnection",
                "kind": "LinkedField",
                "name": "profileFields",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileFieldNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileField",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDefault",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WebFormQuestion",
                            "kind": "LinkedField",
                            "name": "webFormQuestion",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormQuestionOption",
                                "kind": "LinkedField",
                                "name": "options",
                                "plural": true,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "profileFieldsForFiltering",
                "args": (v17/*: any*/),
                "filters": [
                  "search",
                  "status",
                  "defaultTypesToExclude",
                  "isPrivate",
                  "webFormQuestionTypes"
                ],
                "handle": "connection",
                "key": "MembersProfileFieldFilter__profileFieldsForFiltering",
                "kind": "LinkedHandle",
                "name": "profileFields"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e38a0f1452e1b0950df934a1a20b0dc1",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "organization",
            "profileFieldsForFiltering"
          ]
        }
      ]
    },
    "name": "MembersProfileFieldFilterQuery",
    "operationKind": "query",
    "text": "query MembersProfileFieldFilterQuery(\n  $id: ID!\n  $first: Int!\n  $search: String\n  $after: String\n  $isPrivate: Boolean\n  $webFormQuestionTypes: [WebFormQuestionType!]\n) {\n  organization: node(id: $id) {\n    __typename\n    ... on Organization {\n      profileFieldsForFiltering: profileFields(first: $first, after: $after, search: $search, status: visible, defaultTypesToExclude: [email_address, public_groups], isPrivate: $isPrivate, webFormQuestionTypes: $webFormQuestionTypes) {\n        edges {\n          node {\n            id\n            title\n            ...MembersProfileFieldFilterOptionFragment\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          startCursor\n          endCursor\n          hasNextPage\n          hasPreviousPage\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment MembersProfileFieldFilterOptionFragment on ProfileField {\n  id\n  isDefault\n  title\n  webFormQuestion {\n    type\n    options {\n      id\n      label\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d35dfecb5811e8df414ca381d28dab9a";

export default node;
